// Return the current path relative to host
export function currentPath() {
	const href = window.location.href;
	const host = window.location.host;
	return href.substring(href.indexOf(host) + host.length);
}

// Run initial highlight using a provided highlight function
export function runInitialHighlight(highlightRoute) {
	if (typeof highlightRoute !== 'function') { return; }
	const path = currentPath();
	highlightRoute(path);
}
